import React from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { X } from 'react-feather';

import * as styles from './ModalFadeInCenter.module.scss';

type Props = Modal.Props & {
  children: any;
  canClose?: boolean;
};

const ModalFadeInCenter = ({ children, ...props }: Props) => {
  const appElement = typeof document !== 'undefined' ? document.getElementById('___gatsby') : undefined;
  return (
    <Modal
      overlayClassName={styles.modalOverlay}
      bodyOpenClassName={styles.modalIsOpen}
      className={classnames(styles.modalFadeInCenter, {
        [styles.modalFadeIn]: props.isOpen,
        [styles.modalFadeOut]: !props.isOpen,
      })}
      appElement={appElement ?? undefined}
      {...props}
    >
      {props.canClose && <X onClick={props.onRequestClose} className={classnames('black-4', styles.modalCloseCross)} size={20} />}
      {children}
    </Modal>
  );
};

export default ModalFadeInCenter;
